import { normalize } from "normalizr";

const parseResponseMiddleware = () => (next) => (action) => {
  const { schema, response } = action;

  if (!schema || !response) {
    return next(action);
  }

  return next({
    ...action,
    response: normalize(response, schema),
  });
};

export default parseResponseMiddleware;
